import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams, ResponseContentType } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class DocumentsHttpService {

  public static CONTRACT_FILES_URL = DevelopUtil.url('leaseContract/attach');

  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  getDocument(urlSearchParams: URLSearchParams, id): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = ResponseContentType.Blob;
    return this.http.get(DocumentsHttpService.CONTRACT_FILES_URL + '/' + id, this.requestOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/documents/documents.http.service.ts